"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = exports.HydraTableContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var HydraTableContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    position: relative;\n"])));

exports.HydraTableContainer = HydraTableContainer;

var Loading = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 2;\n    pointer-events: none;\n    transition: background-color 0.2s ease-in;\n    padding-top: 20vh;\n\n    &.nestedTable {\n        padding-top: 0;\n    }\n\n    &.loading {\n        pointer-events: all;\n        background-color: ", ";\n        &.nestedTable {\n            background-color: #fff;\n        }\n    }\n"])), function (props) {
  return props.theme.admin.colors.background;
});

exports.Loading = Loading;